<template>
  <div
    class="collection__products-item product-item"
    @mouseover="rollover = true"
    @mouseleave="rollover = false">
    <a class="product-item__link" :href="url">
      <!-- Image -->
      <div
        class="product-item__image-wrapper lazy-container"
        style="--aspect-ratio: 1;"
        @mouseover="hover = true"
        @mouseleave="hover = false">
        <transition name="fade">
          <img
            v-show="activeImage"
            :data-src="activeImage"
            class="lazyload"
            :class="{ 'lazyload': hover, 'remove-transition': lazyloaded }"
            ref="image"
            :alt="product.title">
        </transition>
        <div
          v-if="lazyloaded < 3"
          class="site-loading"
          :class="{ 'activated': hover }">
          <div class="half-circle-spinner">
            <div class="circle circle-1"></div>
            <div class="circle circle-2"></div>
          </div>
        </div>
        <transition name="fade">
          <div
            class="product-item__hover-description"
            v-show="hoverDescription && hover">
            <p>{{ hoverDescription }}</p>
          </div>
        </transition>
      </div>
      <!-- Title -->
      <span class="product-item__title">
        {{ product.title }}
      </span>
      <!-- Price -->
      <p class="product-item__price">
        <div v-if="price" v-html="price"></div>
      </p>
      <!-- Quick Shop -->
      <button class="btn btn--secondary">Buy</button>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ProductItem',
  props: [ 'product', 'collection' ],
  data () {
    return {
      price: null,
      hover: false,
      hoverDescription: null,
      lazyloaded: 0,
    }
  },
  computed: {
    handle () {
      return this.product.handle
    },
    title () {
      return this.product.title.replace(this.product.vendor, '')
    },
    url () {
      return typeof this.collection != 'undefined' ? `/collections/${ this.collection }/products/${ this.handle }` : `/collections/${ this.product.collections[0].handle }/products/${ this.handle }`
    },
    activeImage () {
      if (this.hover) return this.product.images[2] ? this.product.images[2] : this.product.images[1]
      return this.product.images[1]
    },
  },
  mounted () {
    fetch(`/products/${ this.handle }?view=metafields`)
      .then(res => res.json())
      .then(data => {
        this.hoverDescription = data.collection_hover_text.value
        this.price = data.price.value;
      })
    this.$refs.image.addEventListener('lazyloaded', () => {
      this.lazyloaded += 1
    })
  }
}
</script>
